import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"
import Teleformulaire from "../../components/Teleformulaire/teleformulaire"
import PropTypes from "prop-types"
import Ariane from "../../components/Ariane/ariane"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeTeleformulaires(path: { alias: { eq: $slug } }) {
      ...TeleformItem
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Component---------------------------//

const TeleformTemplate = ({ data }) => {
  const teleformulaire = data.nodeTeleformulaires
  const allTaxos = teleformulaire.relationships.field_taxonomie_teleformulaire
    .map((taxo) => {
      return taxo.name
    })
    .join()
  return (
    <Layout isDetail={true}>
      <SEO
        title={teleformulaire.title}
        description={
          "Dans cette page, vous découvrez le téléformulaire suivant : " +
          teleformulaire.title +
          ", mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
      />
      <Ariane isListing={true} pageName={teleformulaire.title} />
      <Teleformulaire teleform={teleformulaire} />
    </Layout>
  )
}

//-----------------------Component---------------------------//

//-----------------------Prop-Types---------------------------//

TeleformTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default TeleformTemplate
